import { schema } from 'normalizr';
import serializeSpecificDateWithTimeZone from 'common/utils/serialize/serializeSpecificDateWithTimeZone';

const busPaxManifestMarkerSchema = new schema.Entity(
  'busPaxManifestMarker',
  {},
  {
    idAttribute: value =>
      `${value.agentId}-${value.agentName}-${serializeSpecificDateWithTimeZone(
        value.verificationDateTime
      )}`,
  }
);

export default busPaxManifestMarkerSchema;
